import { TableCell } from "@mui/material"
import { getFullNameOrEmail } from "../../../../../redux/user"
import { TeamMember } from "../../../../../types"
import { ProgramForm, ProgramFormFilter, TrainingProgramForm } from "../../types"
import HighlightedSearchText from "./HighlightedSearchText"

const UploadedByCell = (props: {
  form: ProgramForm,
  isCollapsedCell: boolean,
  trainingProgramForm: TrainingProgramForm | null,
  tableCellStyles: any,
  colIndex: number,
  colWidths: number[],
  teamMembersById: Map<number, TeamMember>,
  formTeamMembers: TeamMember[],
  filter: ProgramFormFilter | null
  searchValue: string;
  sectionId: number
}) => {
  const {
    form,
    isCollapsedCell,
    tableCellStyles,
    colIndex,
    colWidths,
    trainingProgramForm, 
    teamMembersById,
    filter,
    searchValue,
    sectionId
  } = props

  const userId = trainingProgramForm?.uploaded_by ?? 0
  const user = teamMembersById.get(userId)

  const values = {
    cell: userId ? getFullNameOrEmail(user) : '',
    filter: filter && filter.value !== 'None' ? filter.value : '',
  }

  const sx = isCollapsedCell || (form.is_practice_only && !form.is_multiple_uploads ) ? {...tableCellStyles, width: colWidths[colIndex]} : tableCellStyles

  return (
    <TableCell
      sx={sx}
      align="center"
    >
      {
        isCollapsedCell || (form.is_practice_only && !form.is_multiple_uploads && trainingProgramForm?.section_id === sectionId)  ?
          <HighlightedSearchText
            text={values.cell}
            searchValue={searchValue}
            filterValue={values.filter}
          />
        : null
      }
    </TableCell>
  )
}

export default UploadedByCell